<div class="spinner-border text-primary">
    <span class="visually-hidden" id="loading">Data is loading</span>
</div>
